import { ISO_REQUEST_SEARCH_START_LOADING, ISO_REQUEST_SEARCH_END_LOADING, ISO_REQUEST_SEARCH_LOADED, SET_ISO_REQUEST_FILTER } from "../constants/IsoRequestConstants";
import { ISO_REQUEST_NOTIFY_START_LOADING, ISO_REQUEST_NOTIFY_END_LOADING, ISO_REQUEST_NOTIFY_LOADED, SET_ISO_REQUEST_NOTIFY_FILTER } from "../constants/IsoRequestConstants";
import { ISO_REQUEST_START_LOADING, ISO_REQUEST_END_LOADING, ISO_REQUEST_LOADED } from "../constants/IsoRequestConstants";
import { ISO_REQUEST_INVOICE_START_LOADING, ISO_REQUEST_INVOICE_END_LOADING, ISO_REQUEST_INVOICE_LOADED } from "../constants/IsoRequestConstants";
import { ISO_REQUEST_ITEM_START_LOADING, ISO_REQUEST_ITEM_END_LOADING, ISO_REQUEST_ITEM_LOADED } from "../constants/IsoRequestConstants";
import { ISO_REQUEST_RELATED_START_LOADING, ISO_REQUEST_RELATED_END_LOADING, ISO_REQUEST_RELATED_LOADED } from "../constants/IsoRequestConstants";
import { ISO_REQUEST_CERTIFICATE_START_LOADING, ISO_REQUEST_CERTIFICATE_END_LOADING, ISO_REQUEST_CERTIFICATE_LOADED } from "../constants/IsoRequestConstants";

import { getApiData, postApiJsonData, downloadFile } from "../utils/index";
import * as commonActions from "./CommonActions";

export function loadIsoRequestSearch(filters, navigate) {
    return async (dispatch) => {
        
        await dispatch({ type: ISO_REQUEST_SEARCH_START_LOADING });

        try {

            var data = await postApiJsonData("IsoRequest/GetPaged", filters, null);
            
            if(data.success) {
                await dispatch({
                    type: ISO_REQUEST_SEARCH_LOADED,
                    payload: {
                        dataList: data.responseEntities[0].dataList
                        , searchList: data.responseEntities[0].userSearches
                        , totalCount: data.responseEntities[0].totalCount
                    }
                });
            }
            else {
                if(data.errorCode == "401") {
                    navigate('/not-authorized/');
                }

                dispatch(commonActions.setErrorMessage(data.errorDesc));
            }
            
			await dispatch({ type: ISO_REQUEST_SEARCH_END_LOADING });
        } 
        catch (error) {
            dispatch(commonActions.setErrorMessage(error));
            await dispatch({ type: ISO_REQUEST_SEARCH_END_LOADING });
        }
    };
}

export function downloadIsoRequestSearch(filters, documentName) {
    return async (dispatch) => {
            
        await dispatch({ type: ISO_REQUEST_SEARCH_START_LOADING });

        try {

            var data = await downloadFile("IsoRequest/ExportToExcel", filters);
            
            if(data.success) {
                var url = window.URL.createObjectURL(data.file);
                var a = document.createElement('a');
                a.href = url;
                a.download = documentName;
                document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
                a.click();    
                a.remove();
            }
            else {
                dispatch(commonActions.setErrorMessage(data.errorDesc));
            }

            await dispatch({ type: ISO_REQUEST_SEARCH_END_LOADING });
        } 
        catch (error) {
            dispatch(commonActions.setErrorMessage(error));
            await dispatch({ type: ISO_REQUEST_SEARCH_END_LOADING });
        }
    };
}

export function setIsoRequestFilter(filter) {
    return async (dispatch) => {
        await dispatch({
            type: SET_ISO_REQUEST_FILTER,
            payload: filter
        });
    };
}

export function loadIsoRequestNotifySearch(filters, navigate) {
    return async (dispatch) => {
        
        await dispatch({ type: ISO_REQUEST_NOTIFY_START_LOADING });

        try {

            var data = await postApiJsonData("IsoCertificate/GetPaged", filters, null);
            
            if(data.success) {
                await dispatch({
                    type: ISO_REQUEST_NOTIFY_LOADED,
                    payload: {
                        dataList: data.responseEntities[0].dataList
                        , searchList: data.responseEntities[0].userSearches
                        , totalCount: data.responseEntities[0].totalCount
                    }
                });
            }
            else {
                if(data.errorCode == "401") {
                    navigate('/not-authorized/');
                }

                dispatch(commonActions.setErrorMessage(data.errorDesc));
            }
            
			await dispatch({ type: ISO_REQUEST_NOTIFY_END_LOADING });
        } 
        catch (error) {
            dispatch(commonActions.setErrorMessage(error));
            await dispatch({ type: ISO_REQUEST_NOTIFY_END_LOADING });
        }
    };
}

export function downloadIsoRequestNotifySearch(filters, documentName) {
    return async (dispatch) => {
            
        await dispatch({ type: ISO_REQUEST_NOTIFY_START_LOADING });

        try {

            var data = await downloadFile("IsoCertificate/ExportToExcel", filters);

            if(data.success) {
                var url = window.URL.createObjectURL(data.file);
                var a = document.createElement('a');
                a.href = url;
                a.download = documentName;
                document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
                a.click();    
                a.remove();
            }
            else {
                dispatch(commonActions.setErrorMessage(data.errorDesc));
            }

            await dispatch({ type: ISO_REQUEST_NOTIFY_END_LOADING });
        } 
        catch (error) {
            dispatch(commonActions.setErrorMessage(error));
            await dispatch({ type: ISO_REQUEST_NOTIFY_END_LOADING });
        }
    };
}

export function setIsoRequestNotifyFilter(filter) {
    return async (dispatch) => {
        await dispatch({
            type: SET_ISO_REQUEST_NOTIFY_FILTER,
            payload: filter
        });
    };
}

export function loadIsoRequest(id, navigate) {
    return async (dispatch) => {
        
        await dispatch({ type: ISO_REQUEST_START_LOADING });

        try {

            var data = await getApiData("IsoRequest/GetIsoRequestFBO", { id });
            
            if(data.success) {
                await dispatch({
                    type: ISO_REQUEST_LOADED,
                    payload: data.responseEntities[0]
                });
            }
            else {
                if(data.errorCode == "401") {
                    navigate('/not-authorized/');
                    dispatch(commonActions.setErrorMessage(data.errorDesc));
                }
                else if(data.errorCode == "402") {
                    if(data.companyId && data.companyId > 0) {
                        navigate('/invalid-company/iso/' + data.companyId + "/" + data.moduleName + "/" + id);
                    }
                    else {
                        navigate('/invalid-company');
                        dispatch(commonActions.setErrorMessage(data.errorDesc));
                    }
                }
                else {
                    dispatch(commonActions.setErrorMessage(data.errorDesc));
                }
            }
            
			await dispatch({ type: ISO_REQUEST_END_LOADING });
        } 
        catch (error) {
            dispatch(commonActions.setErrorMessage(error));
            await dispatch({ type: ISO_REQUEST_END_LOADING });
        }
    };
}

export function saveIsoRequest(fbo, status, message, invoice, navigate) {
    return async (dispatch) => {
        
        await dispatch({ type: ISO_REQUEST_START_LOADING });

        try {

            var isAdd = fbo.isAddMode;
            var data = await postApiJsonData("IsoRequest/SaveIsoRequestFBO", { status, message }, fbo);
            
            if(data.success) {
                if(isAdd) {
                    navigate('/iso-request-edit/' + data.responseEntities[0].isoRequest.id);
                    dispatch(commonActions.setSuccessMessage("ISO Ticket Created Successfully!"));
                }
                else {
                    await dispatch({
                        type: ISO_REQUEST_LOADED,
                        payload: data.responseEntities[0]
                    });
                    
                    if(invoice) {
                        //TODO:
                        //dispatch(createInvoice(fbo.isoRequest.id, navigate));
                    }
                    else {
                        dispatch(commonActions.setSuccessMessage("ISO Ticket Saved Successfully!"));
                    }
                }
            }
            else {
                dispatch(commonActions.setErrorMessage(data.errorDesc));
            }

			await dispatch({ type: ISO_REQUEST_END_LOADING });
        } 
        catch (error) {
            dispatch(commonActions.setErrorMessage(error));
            await dispatch({ type: ISO_REQUEST_END_LOADING });
        }
    };
}

export async function validateIsoRequestStatusChange(fbo, status) {
    var objReturn = {
        success: false
    };
    
    try {

        var data = await postApiJsonData("IsoRequest/ValidateIsoRequestStatusChange", { status }, fbo);
        
        if(data.success) {
            objReturn.success = true;
        }
        else {
            objReturn.success = false;
        }
    } 
    catch (error) {
        alert(error);
    }

    return objReturn;
}

export async function addCertificateToIsoRequest(isoRequestId, requestType, requestTypeOther, certificateNumber, accreditationType, manDayStandardId) {
    var returnData = {
        success: false,
        errorMessage: "",
        data: null,
        successMessage: "Certificate Added Successfully!"
    };

    try {

        var data = await getApiData("IsoRequest/AddCertificateToIsoRequest", { isoRequestId, requestType, requestTypeOther, certificateNumber, accreditationType, manDayStandardId });

        if(data.success) {
            returnData.success = true;
            returnData.data = data.responseEntities[0];
        }
        else {
            returnData.errorMessage = data.errorDesc;
        }
    } 
    catch (error) {
        returnData.errorMessage = error;
    }

    return returnData;
}

export async function removeCertificate(isoRequestCertificateId) {
    var returnData = {
        success: false,
        errorMessage: "",
        successMessage: "Certificate Removed Successfully!"
    };

    try {

        var data = await getApiData("IsoRequest/RemoveCertificateToIsoRequest", { isoRequestCertificateId });

        if(data.success) {
            returnData.success = true;
        }
        else {
            returnData.errorMessage = data.errorDesc;
        }
    } 
    catch (error) {
        returnData.errorMessage = error;
    }

    return returnData;
}

export function assignMeIsoRequest(isoRequestId, userId, assignMe, navigate) {
    return async (dispatch) => {
        
        await dispatch({ type: ISO_REQUEST_START_LOADING });

        try {

            var data = await postApiJsonData("IsoRequest/AssignIsoRequest", { isoRequestId, userId, assignMe }, null);
            
            if(data.success) {
                dispatch(loadIsoRequest(isoRequestId, navigate));
            }
            else {
                dispatch(commonActions.setErrorMessage(data.errorDesc));
            }
            
			await dispatch({ type: ISO_REQUEST_END_LOADING });
        } 
        catch (error) {
            dispatch(commonActions.setErrorMessage(error));
            await dispatch({ type: ISO_REQUEST_END_LOADING });
        }
    };
}

export async function markProceedWithoutPayment(isoRequestId, commentText) {
    var returnData = {
        success: false,
        errorMessage: "",
        successMessage: "ISO Ticket maked to Proceed without Payment Successfully!"
    };

    try {

        var data = await getApiData("IsoRequest/MarkProceedWithoutPayment", { isoRequestId, commentText });

        if(data.success) {
            returnData.success = true;
        }
        else {
            returnData.errorMessage = data.errorDesc;
        }
    } 
    catch (error) {
        returnData.errorMessage = error;
    }

    return returnData;
}

export async function notifyMarkProceedWithoutPayment(isoRequestId, commentText) {
    var returnData = {
        success: false,
        errorMessage: "",
        successMessage: "Notification to Mark Proceed without Payment Sent Successfully!"
    };

    try {

        var data = await getApiData("IsoRequest/NotifyMarkProceedWithoutPayment", { isoRequestId, commentText });

        if(data.success) {
            returnData.success = true;
        }
        else {
            returnData.errorMessage = data.errorDesc;
        }
    } 
    catch (error) {
        returnData.errorMessage = error;
    }

    return returnData;
}

export async function validateGenerateCertificate(isoRequestId, isoRequestCertificateId) {
    var errorMessages = [];

    try {

        var data = await getApiData("IsoRequest/ValidateGenerateCertificate", { isoRequestId, isoRequestCertificateId });
        
        if(data.success) {
            errorMessages = data.responseEntities[0].errorMessageList;
        }
        else {
            alert(data.errorDesc);
        }
    } 
    catch (error) {
        alert(error);
    }

    return errorMessages;
}

export async function generateCertificate(isoRequestId, isoRequestCertificateId) {
    var returnData = {
        success: false,
        errorMessage: "",
        successMessage: "ISO Ticket Certificate Generated Successfully!"
    };

    try {

        var data = await getApiData("IsoRequest/GenerateCertificate", { isoRequestId, isoRequestCertificateId });

        if(data.success) {
            returnData.success = true;
        }
        else {
            returnData.errorMessage = data.errorDesc;
        }
    } 
    catch (error) {
        returnData.errorMessage = error;
    }

    return returnData;
}

export function generateCertificateDownload(isoRequestId, isoRequestCertificateId) {
    return async (dispatch) => {
        
        await dispatch({ type: ISO_REQUEST_START_LOADING });

        try {

            var data = await downloadFile("IsoRequest/DownloadCertificate", { isoRequestId, isoRequestCertificateId });
            
            if(data.success) {
                var url = window.URL.createObjectURL(data.file);
                var a = document.createElement('a');
                a.href = url;
                a.download = "Certificate.docx";
                document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
                a.click();    
                a.remove();
            }
            else {
                dispatch(commonActions.setErrorMessage(data.errorDesc));
            }

            await dispatch({ type: ISO_REQUEST_END_LOADING });
        } 
        catch (error) {
            dispatch(commonActions.setErrorMessage(error));
            await dispatch({ type: ISO_REQUEST_END_LOADING });
        }
    };
}

export async function GetIsoCertificateView(isoCertificateId) {
    var returnData = {
        success: false,
        errorMessage: "",
        list: []
    };

    try {

        var data = await getApiData("IsoCertificate/GetIsoCertificateView", { isoCertificateId }, false);
        
        if(data.success) {
            returnData.success = true;
            returnData.list = data.responseEntities;
        }
        else {
            returnData.errorMessage = data.errorDesc;
        }
    } 
    catch (error) {
        returnData.errorMessage = error;
    }

    return returnData;
}

export async function generateMdc(isoRequestId, groupId) {
    var returnData = {
        success: false,
        errorMessage: "",
        successMessage: "ISO Ticket MDC Document Generated Successfully!"
    };

    try {

        var data = await getApiData("IsoRequest/GenerateMdc", { isoRequestId, groupId });

        if(data.success) {
            returnData.success = true;
        }
        else {
            returnData.errorMessage = data.errorDesc;
        }
    } 
    catch (error) {
        returnData.errorMessage = error;
    }

    return returnData;
}

export function generateMdcDownload(isoRequestId, groupId) {
    return async (dispatch) => {
        
        await dispatch({ type: ISO_REQUEST_START_LOADING });

        try {

            var data = await downloadFile("IsoRequest/DownloadMdc", { isoRequestId, groupId });
            
            if(data.success) {
                var url = window.URL.createObjectURL(data.file);
                var a = document.createElement('a');
                a.href = url;
                a.download = "FM-BA-ZET-MS-All-003-MDC-EN.docx";
                document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
                a.click();    
                a.remove();
            }
            else {
                dispatch(commonActions.setErrorMessage(data.errorDesc));
            }

            await dispatch({ type: ISO_REQUEST_END_LOADING });
        } 
        catch (error) {
            dispatch(commonActions.setErrorMessage(error));
            await dispatch({ type: ISO_REQUEST_END_LOADING });
        }
    };
}

export function viewInvoice(id, crmInvoiceId, navigate) {
    return async (dispatch) => {
        
        await dispatch({ type: ISO_REQUEST_INVOICE_START_LOADING });

        try {

            var data = await getApiData("Invoice/GetIsoInvoice", { id, crmInvoiceId });
            
            if(data.success) {
                await dispatch({
                    type: ISO_REQUEST_INVOICE_LOADED,
                    payload: data.responseEntities[0]
                });
            }
            else {
                dispatch(commonActions.setErrorMessage(data.errorDesc));
            }

            await dispatch({ type: ISO_REQUEST_INVOICE_END_LOADING });
        } 
        catch (error) {
            dispatch(commonActions.setErrorMessage(error));
            await dispatch({ type: ISO_REQUEST_INVOICE_END_LOADING });
        }
    };
}

export async function removeInvoice(isoRequestId, paymentId) {
    var returnData = {
        success: false,
        errorMessage: "",
        successMessage: "Invoice Linking Removed Successfully!"
    };

    try {

        var data = await getApiData("IsoRequest/RemoveInvoice", { isoRequestId, paymentId });

        if(data.success) {
            returnData.success = true;
        }
        else {
            returnData.errorMessage = data.errorDesc;
        }
    } 
    catch (error) {
        returnData.errorMessage = error;
    }

    return returnData;
}

export function loadIsoRequestItems(isoRequestId) {
    return async (dispatch) => {
        
        await dispatch({ type: ISO_REQUEST_ITEM_START_LOADING });

        try {

            var data = await getApiData("IsoRequest/GetIsoRequestItems", { isoRequestId });
            
            if(data.success) {
                await dispatch({
                    type: ISO_REQUEST_ITEM_LOADED,
                    payload: data.responseEntities
                });
            }
            else {
                dispatch(commonActions.setErrorMessage(data.errorDesc));
            }
            
            await dispatch({ type: ISO_REQUEST_ITEM_END_LOADING });
        } 
        catch (error) {
            dispatch(commonActions.setErrorMessage(error));
            await dispatch({ type: ISO_REQUEST_ITEM_END_LOADING });
        }
    };
}

export function loadIsoRelatedRequest(isoRequestId, customerId) {
    return async (dispatch) => {
        
        await dispatch({ type: ISO_REQUEST_RELATED_START_LOADING });

        try {

            var data = await getApiData("IsoRequest/GetIsoRelatedRequests", { isoRequestId, customerId });
            
            if(data.success) {
                await dispatch({
                    type: ISO_REQUEST_RELATED_LOADED,
                    payload: data.responseEntities
                });
            }
            else {
                dispatch(commonActions.setErrorMessage(data.errorDesc));
            }
            
			await dispatch({ type: ISO_REQUEST_RELATED_END_LOADING });
        } 
        catch (error) {
            dispatch(commonActions.setErrorMessage(error));
            await dispatch({ type: ISO_REQUEST_RELATED_END_LOADING });
        }
    };
}

export function loadIsoCertificate(id, navigate) {
    return async (dispatch) => {
        
        await dispatch({ type: ISO_REQUEST_CERTIFICATE_START_LOADING });

        try {

            var data = await getApiData("IsoCertificate/GetIsoCertificateFBO", { id });
            
            if(data.success) {
                await dispatch({
                    type: ISO_REQUEST_CERTIFICATE_LOADED,
                    payload: data.responseEntities[0]
                });
            }
            else {
                if(data.errorCode == "401") {
                    navigate('/not-authorized/');
                    dispatch(commonActions.setErrorMessage(data.errorDesc));
                }
                else {
                    dispatch(commonActions.setErrorMessage(data.errorDesc));
                }
            }
            
			await dispatch({ type: ISO_REQUEST_CERTIFICATE_END_LOADING });
        } 
        catch (error) {
            dispatch(commonActions.setErrorMessage(error));
            await dispatch({ type: ISO_REQUEST_CERTIFICATE_END_LOADING });
        }
    };
}

export function saveIsoCertificate(fbo) {
    return async (dispatch) => {
        
        await dispatch({ type: ISO_REQUEST_CERTIFICATE_START_LOADING });

        try {

            var data = await postApiJsonData("IsoCertificate/SaveIsoCertificateFBO", { }, fbo);
            
            if(data.success) {
                await dispatch({
                    type: ISO_REQUEST_CERTIFICATE_LOADED,
                    payload: data.responseEntities[0]
                });
                    
                dispatch(commonActions.setSuccessMessage("ISO Certificate Saved Successfully!"));
            }
            else {
                dispatch(commonActions.setErrorMessage(data.errorDesc));
            }

			await dispatch({ type: ISO_REQUEST_CERTIFICATE_END_LOADING });
        } 
        catch (error) {
            dispatch(commonActions.setErrorMessage(error));
            await dispatch({ type: ISO_REQUEST_CERTIFICATE_END_LOADING });
        }
    };
}

export async function generateWithdrawalLetter(isoCertificateId) {
    var returnData = {
        success: false,
        errorMessage: "",
        successMessage: "Withdrawal Letter Generated Successfully!"
    };

    try {

        var data = await getApiData("IsoRequest/GenerateWithdrawalLetter", { isoCertificateId });

        if(data.success) {
            returnData.success = true;
        }
        else {
            returnData.errorMessage = data.errorDesc;
        }
    } 
    catch (error) {
        returnData.errorMessage = error;
    }

    return returnData;
}